export function isAWSPresignedUrl(url) {
    return typeof url !== "string";
}
export function isAzurePresignedUrl(url) {
    return typeof url === "string" && url.startsWith("azure");
}
export function isGCPPresignedUrl(url) {
    return typeof url === "string" && url.startsWith("gs");
}
export class DatasetFieldUtils {
    static isNumeric(field) {
        if (field.type == "number") {
            return true;
        }
        else if (DatasetFieldUtils.isCategorical(field)) {
            return (field.data ?? []).every((x) => !isNaN(Number(x.value)));
        }
        else {
            return false;
        }
    }
    static isCategorical(field) {
        return field.type == "categorical";
    }
    static isDate(field) {
        return field.type == "date";
    }
}
